<div class="row">
  <div class="col-12">
    <div class="form-group" [formGroup]="form">
      <label for="levsattkod" translate> X2F_LEVSATTBESKR </label>
      <select formControlName="levsattkod" name="levsattkod" id="levsattkod" class="form-control form-select">
        <option [value]="deliveryOption.id" *ngFor="let deliveryOption of deliveryOptions">
          {{ deliveryOption.value }}
        </option>
      </select>
    </div>
    <!-- <div [formGroup]="form">
            <lib-meta-select-input formControlName="levsattkod" table="x2f" metaId="levsattkod"
                metaDisplay="levsattbeskr">
            </lib-meta-select-input>
        </div> -->
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div [formGroup]="form">
      <lib-delivery-date-picker
        [label]="'COLMEC_DELIVERY_DATE'"
        (selectedDate)="dateSelected($event)"
        [deliveryMethod]="selectedLevsattkod"
      ></lib-delivery-date-picker>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="form-group">
      <label for="oh.editext" lass="control-label" translate>MESSAGE</label>
      <textarea
        class="form-control"
        type="text"
        name="editext"
        id="oh.editext"
        [(ngModel)]="checkout.extra.oh.editext"
      ></textarea>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div
      *ngIf="alertMessage"
      class="alert mt-2 text-center"
      role="alert"
      [ngClass]="{ 'alert-success': alertMessage.type === 'success', 'alert-danger': alertMessage.type === 'danger' }"
      (click)="alertMessage = null"
    >
      <span>{{ alertMessage.message | translate }}</span>
    </div>
  </div>

  <ng-template #loading translate> LOADING </ng-template>
</div>
